
import { Component, Prop, Vue } from "vue-property-decorator";
import Faq from "@/models/Faq";

@Component
export default class FaqTemplate extends Vue {
  @Prop() faq!: Faq;
}
